import React, { useEffect, useState, useMemo } from "react";
import { Modal, Table, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
import Swal from "sweetalert2";
import { TbUserDollar } from "react-icons/tb";
import { getgastosbyliquidacion } from "../../../../api/marcacionApi";

const normalizar = (str = "") =>
  str
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

const ModalAllGastos = ({ estado, onCloseModal, onReturnValue }) => {
  const [allGastos, setAllGastos] = useState([]);
  const [loading, setLoading] = useState(false);

  // Filtros solo texto libre
  const [pacienteFilter, setPacienteFilter] = useState("");
  const [usuarioFilter, setUsuarioFilter] = useState("");

  useEffect(() => {
    const fetchAllGastos = async () => {
      try {
        setLoading(true);
        Swal.fire({
          title: "Cargando Gastos",
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
          didOpen: () => Swal.showLoading(),
        });
        const data = await getgastosbyliquidacion(0);
        setAllGastos(data || []);
        Swal.close();
      } catch (err) {
        Swal.close();
        Swal.fire({ icon: "error", title: "Oops...", text: `${err}` });
      } finally {
        setLoading(false);
      }
    };

    if (estado) {
      // Reset filtros al abrir
      setPacienteFilter("");
      setUsuarioFilter("");
      fetchAllGastos();
    }
  }, [estado]);

  const filteredGastos = useMemo(() => {
    const pacTxt = normalizar(pacienteFilter);
    const usuTxt = normalizar(usuarioFilter);

    return allGastos.filter(g => {
      const pac = normalizar(g.paciente || "");
      const usu = normalizar(g.usuario || "");
      const okPac = !pacTxt || pac.includes(pacTxt);
      const okUsu = !usuTxt || usu.includes(usuTxt);
      return okPac && okUsu;
    });
  }, [allGastos, pacienteFilter, usuarioFilter]);

  const clearFilters = () => {
    setPacienteFilter("");
    setUsuarioFilter("");
  };

  return (
    <Modal show={estado} onHide={onCloseModal} size="xl" backdrop="static" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Todos los Gastos</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <Row className="g-2 mb-3">
          <Col md={4} lg={3}>
            <Form.Label className="mb-1">Buscar Usuario</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="..."
                value={pacienteFilter}
                onChange={(e) => setPacienteFilter(e.target.value)}
              />
            </InputGroup>
          </Col>
          <Col md={4} lg={3}>
            <Form.Label className="mb-1">Buscar Cuenta</Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="..."
                value={usuarioFilter}
                onChange={(e) => setUsuarioFilter(e.target.value)}
              />
            </InputGroup>
          </Col>
          <Col md={4} lg={3} className="d-flex align-items-end">
            <Button
              variant="outline-danger"
              size="sm"
              onClick={clearFilters}
              disabled={!pacienteFilter && !usuarioFilter}
            >
              Limpiar filtros
            </Button>
          </Col>
          <Col className="d-flex align-items-end justify-content-end">
            <small className="text-muted">
              Mostrando {filteredGastos.length} de {allGastos.length} registros
              {loading && " (cargando...)"}
            </small>
          </Col>
        </Row>

        <Table responsive bordered hover size="sm" className="primary-table-bordered">
          <thead className="thead-primary">
            <tr>
              <th style={{ width: 70 }}>ID</th>
              <th>Detalle</th>
              <th style={{ width: 110 }}>Monto</th>
              <th style={{ width: 220 }}>Paciente</th>
              <th style={{ width: 180 }}>Usuario</th>
              <th style={{ width: 90 }}>Acción</th>
            </tr>
          </thead>
          <tbody>
            {filteredGastos.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center text-muted">
                  No hay resultados con los filtros aplicados.
                </td>
              </tr>
            )}
            {filteredGastos.map((gasto, index) => (
              <tr key={index}>
                <td>{gasto.idgastoenfermeria}</td>
                <td
                  style={{
                    maxWidth: 400,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "normal",
                  }}
                  title={gasto.gasto}
                >
                  {gasto.gasto}
                </td>
                <td>{gasto.monto?.toLocaleString("es")}</td>
                <td>{gasto.paciente}</td>
                <td>{gasto.usuario}</td>
                <td className="text-center">
                  <Button
                    onClick={() => onReturnValue(gasto)}
                    variant="primary"
                    className="p-1"
                    title="Seleccionar gasto"
                  >
                    <TbUserDollar /> +
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAllGastos;